import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { UserService } from "../services/user-service";
import { CanActivateFn } from "@angular/router";

export const RequiresCreateAccountGuard: CanActivateFn = () => {
    const user = inject(UserService);
    const router = inject(Router);

    return user.getUserStatus().pipe(map(s => s.status == "LoggedIn" && !s.user ? true : router.createUrlTree(["switch"])));
}